import {CURRENT_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'

const axios = require('axios')

export default {
  getServiceProvider: function ({limit = 30, page = 1, sort, search, status, tags}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, sort]
    if (search) query.push(`search=${search}`)
    if (status) query.push(`status[]=${status}`)
    if (tags) query.push(`vendorTags[]=${tags}`)
    const api = search ? 'serviceproviders?' : 'serviceproviders/withoutelastic?'
    return instCred.get(api + query.join('&'))
  },
  getGoodsServiceProvider: function ({limit = 30, page = 1, sort, search}) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`, sort]
    if (search) query.push(`service[]=${search}`)
    const api = 'serviceproviders/withoutelastic?';
    return instCred.get(api + query.join('&'))
  },
  getServiceProviderItem: function (idServiceProvider) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('serviceproviders/' + idServiceProvider)
  },
  createServiceProvider: function (serviceProvider) {
    serviceProvider.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('serviceproviders', serviceProvider)
  },
  deleteServiceProvider: function (idServiceProvider) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('serviceproviders/' + idServiceProvider)
  },
  changeServiceProvider: function (serviceProvider) {
    serviceProvider.company = VueCookie.get('company')
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put('serviceproviders/' + serviceProvider.id, serviceProvider)
  }
}



// WEBPACK FOOTER //
// ./src/api/ServiceProvider/api.js